/************************************************************
 Medical Act Namespace
 ************************************************************/

window.medicalAct = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        // Cancel Order
        if (actionId == 3) {
            medicalAct.openReason(medicalAct.cancelReasonModalHandler);
        }
        else if (actionId==7)
        {
            medicalAct.openAct(medicalAct.executeMedicalModal);
        }
        // Other actions
        else  {
            medicalAct.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeAction(medicalAct._action, medicalAct._callback, medicalAct._row);
    },
    // Open Reason
    openReason:function (callback) {
        var params = {
            item_id:medicalAct._row.item_id,
            wf_id:medicalAct._action.wf_id,
            wf_status_id:medicalAct._row.wf_status_id,
            wf_action_id:medicalAct._action.wf_action_id};

        debug.log("openReason", params);

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                debug.log("sucesso");
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                debug.log("generic_reason_window", data);
                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                debug.log("erro");
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                medicalAct._callback(false, medicalAct._action, medicalAct._row);
            });
    },


    // Cancel Act
    cancelReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        debug.log("cancelReasonModalHandler", data);
        var params = {
            item_id:medicalAct._row.item_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id:medicalAct._row.wf_id,
            wf_status_id:medicalAct._row.wf_status_id,
            wf_action_id:data.actionId};


        $.post('/patients/cancel_medical_acts', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    medicalAct._callback(false, medicalAct._action, medicalAct._row);
                } else {
                    medicalAct._callback(true, medicalAct._action, medicalAct._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                medicalAct._callback(false, medicalAct._action, medicalAct._row);
            });
    },

    openAct:function(callback){

        var params = {
            item_id:medicalAct._row.item_id,
            wf_id:medicalAct._action.wf_id,
            id:medicalAct._row.id,
            wf_status_id:medicalAct._action.to_state_id,
            wf_action_id:medicalAct._action.wf_action_id,
            professional_name:medicalAct._row.prof_desc_last,
            professional_id:medicalAct._row.professional_id,
            medical_act_name:medicalAct._row.desc
            };


        $.get('/ambulatory/acts/acts_edit',params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#edit-acts-ct').bind('actEdited', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },

    executeMedicalModal:function(event,data){
        $.fancybox.close(true);


            var params = {};

            params.medical_act_name=medicalAct._row.medical_act_name;
            params.professional_id = medicalAct._row.professional_id;
            params.date = medicalAct._row.date;
            params.hour =  medicalAct._row.hour;
            params.notes = medicalAct._row.notes;
            params.item_id= medicalAct._row.item_id;



            var date = new Date();
            if (params.date == null || params.date.trim().length == 0) {
                params.date = Hades.formatDate(date.getDate(), date.getMonth(), date.getFullYear());
            }

            if (params.hour == null || params.hour.trim().length == 0) {
                params.hour = date.getHours() + ':' + date.getMinutes();
            }

             $.post('/patients/execute_medical_acts', params,null,'json')
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    if (data.success != true) {
                        Hades.showError(Hades.genericErrorMsg(), data.error);
                        Hades.hideLoading();
                        medicalAct._callback(false, medicalAct._action, medicalAct._row);
                    } else {
                        medicalAct._callback(true, medicalAct._action, medicalAct._row);
                    }

                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                    medicalAct._callback(false, medicalAct._action, medicalAct._row);
                });

    }
};